/////////////////////////////////////////////////////
// Add your custom code here.
// This file and any changes you make to it are preserved every time the app is generated.
/////////////////////////////////////////////////////
import { Inject, Injector, Component } from "@angular/core";
import { LandingPageViewBaseComponent } from "./landing-page.view.base.component";
import { progress } from "@progress/jsdo-core";
import { CustomAuthorizationService } from "../../../core/auth/custom-authorization.service";
import { ScreenSizeService } from "../../../shared/services/screen-size.service";

@Component({
    templateUrl: "./landing-page.view.component.extend.html",
    styleUrls: ["./landing-page.view.component.css"],
})
export class LandingPageViewComponent extends LandingPageViewBaseComponent {
    public serviceStatistics = {
        ServicesNew: 0,
        ServicesChanged: 0,
        ServicesConfirmed: 0,
    };

    public groupServiceStatistics = {
        GroupsPlanned: 0,
        GroupsConfirmed: 0,
        GroupsCancelled: 0,
    };

    public transferStatistics = [];

    public supplierStatusStatistics = [];
    public groupStatusStatistics = [];
    public groupServicesStatistics = [];
    public exchangePointStatistics = [];
    public guidedToursStatistics = [];

    public showGroupBooking: boolean = false;
    public showBookings: boolean = false;
    public showHistoricalBookings = false;
    public showExchangePoint = false;
    public showContactInfo: boolean = false;
    public showServiceLine: boolean = false;
    public showServices: boolean = false;
    public showShuttleService: boolean = false;
    public showGuidedTours: boolean = false;
    public initFinished = false;
    public isMobile: boolean = false;

    private screenSizeService: ScreenSizeService;

    constructor(
        @Inject(Injector) injector: Injector,
        @Inject(CustomAuthorizationService)
        protected customAuthorizationService: CustomAuthorizationService
    ) {
        super(injector);
        this.screenSizeService = injector.get(ScreenSizeService);

        Promise.all([
            this.customAuthorizationService.processAuthorizationResponse(),
        ]).then(() => {
            this.showGroupBooking =
                this.customAuthorizationService.showGroupBooking;
            this.showBookings = this.customAuthorizationService.showBookings;
            this.showHistoricalBookings =
                this.customAuthorizationService.showHistoricalBookings;
            this.showExchangePoint =
                this.customAuthorizationService.showExchangePoint;
            this.showContactInfo =
                this.customAuthorizationService.showContactInfo;
            this.showServiceLine =
                this.customAuthorizationService.showServiceLine;
            this.showServices = this.customAuthorizationService.showServices;
            this.showShuttleService =
                this.customAuthorizationService.showShuttleService;
            this.showGuidedTours =
                this.customAuthorizationService.showGuidedTours;

            Promise.all([
                this.readServiceStatistics(),
                this.readGroupStatusStatistics(),
                this.readTransferStatistics(),
                this.readGroupServicesStatistics(),
                this.readExchangePointStatistics(),
                this.readGuidedToursStatistics(),
            ]).then(() => {
                this.initFinished = true;
            });
        });
    }

    public get $modulesFirstRow() {
        let modules = [];
        if (this.showBookings)
            modules.push(this.$modules.find((mod) => mod.name == "Booking"));
        if (this.showContactInfo)
            modules.push(this.$modules.find((mod) => mod.name == "Contact"));
        return modules;
    }

    public get $modulesSecondRow() {
        let modules = [];
        if (this.showGroupBooking)
            modules.push(
                this.$modules.find((mod) => mod.name == "GroupBooking")
            );
        if (this.showServiceLine)
            modules.push(
                this.$modules.find((mod) => mod.name == "ServiceLine")
            );
        return modules;
    }

    public get $modulesThirdRow() {
        let modules = [];
        if (this.showServices)
            modules.push(
                this.$modules.find((mod) => mod.name == "GroupServices")
            );
        if (this.showHistoricalBookings)
            modules.push(
                this.$modules.find((mod) => mod.name == "HistoricalBookings")
            );
        return modules;
    }

    public get $modulesFourthRow() {
        let modules = [];
        if (this.showShuttleService)
            modules.push(
                this.$modules.find((mod) => mod.name == "ShuttleService")
            );
        if (this.showExchangePoint)
            modules.push(
                this.$modules.find((mod) => mod.name == "ExchangePoint")
            );

        return modules;
    }

    public get $modulesFifthRow() {
        let modules = [];
        if (this.showGuidedTours)
            modules.push(
                this.$modules.find((mod) => mod.name == "GuidedTours")
            );
        return modules;
    }

    public get groupBookingModule() {
        return this.$modules.find((mod) => mod.name == "GroupBooking");
    }
    // Fired when component is initialized and input properties are set
    public onInit(): void {
        this.isMobile = this.screenSizeService.isMobile;
        this.screenSizeService.isMobile$.subscribe(
            (response) => (this.isMobile = response)
        );
    }
    // Fired when component's views and child views are initialized
    public onShow(): void {}
    // Fired just before Angular destroys the component. Unsubscribe Observables and detach event handlers to avoid memory leaks
    public onHide(): void {}

    public async readServiceStatistics() {
        if (!this.showBookings) return;

        const jsdo = new progress.data.JSDO("SupplierBookingBusinessEntity");

        const response = await jsdo.invoke("GetServiceStatistics");

        this.serviceStatistics = response.request.response;
    }

    public async readTransferStatistics() {
        if (!this.showServiceLine) return;

        const jsdo = new progress.data.JSDO("ServiceLineBusinessEntity");

        const response = await jsdo.invoke("GetStatusStatistics");

        this.transferStatistics =
            response.request.response.dsStatusStatistics.dsStatusStatistics.ttStatusStatistics;
    }

    public async readGroupServiceStatistics() {
        // if (!this.showGroupBooking)
        //     return;
        // const jsdo = new progress.data.JSDO("SupplierBookingBusinessEntity");
        // const response = await jsdo.invoke("GetServiceStatistics");
        // this.groupServiceStatistics = response.request.response;
    }

    public async readSupplierStatusStatistics() {
        // if (!this.showGroupBooking)
        //     return;
        // const jsdo = new progress.data.JSDO("SupplierBookingBusinessEntity");
        // const response = await jsdo.invoke("GetStatusStatistics");
        // this.supplierStatusStatistics = response.request.response.dsStatusStatistics.dsStatusStatistics.ttStatusStatistics;
    }

    public async readGroupStatusStatistics() {
        if (!this.showGroupBooking) return;

        const jsdo = new progress.data.JSDO("GroupBookingBusinessEntity");

        const response = await jsdo.invoke("GetStatusStatistics");

        this.groupStatusStatistics =
            response.request.response.dsStatusStatistics.dsStatusStatistics.ttStatusStatistics;
    }

    public async readGroupServicesStatistics() {
        if (!this.showServices) return;

        const jsdo = new progress.data.JSDO("GroupServiceBusinessEntity");

        const response = await jsdo.invoke("GetStatusStatistics");

        this.groupServicesStatistics =
            response.request.response.dsStatusStatistics.dsStatusStatistics.ttStatusStatistics;
    }

    public async readExchangePointStatistics() {
        if (!this.showExchangePoint) return;
        const jsdo = new progress.data.JSDO("ExchangePointBusinessEntity");
        const response = await jsdo.invoke("GetStatusStatistics");
        this.exchangePointStatistics =
            response.request.response.dsStatusStatistics.dsStatusStatistics.ttStatusStatistics;
    }

    public async readGuidedToursStatistics() {
        if (!this.showGuidedTours) return;
        const jsdo = new progress.data.JSDO("GuidedToursBusinessEntity");
        const response = await jsdo.invoke("GetStatusStatistics");
        this.guidedToursStatistics =
            response.request.response.dsStatusStatistics.dsStatusStatistics.ttStatusStatistics;
    }
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/modules/application/landing-page/landing-page.view.component.ts